import { apiClient } from './client';
import { NonconformanceReport } from '../types/nonconformanceReport';
import { QcAnalyticsQuery, QcAnalyticsSummary, QcNcrDrillQuery } from '../types/qcAnalytics';

export async function fetchQcAnalyticsSummary(
  params?: QcAnalyticsQuery
): Promise<QcAnalyticsSummary> {
  const { data } = await apiClient.get<QcAnalyticsSummary>('/qc-analytics/summary', {
    params: {
      from: params?.from || undefined,
      to: params?.to || undefined,
      contractId: params?.contractId ?? undefined,
    },
  });
  return data;
}

export async function fetchQcAnalyticsNcrs(
  params: QcNcrDrillQuery
): Promise<NonconformanceReport[]> {
  const { data } = await apiClient.get<NonconformanceReport[]>('/qc-analytics/ncrs', {
    params: {
      from: params.from || undefined,
      to: params.to || undefined,
      contractId: params.contractId ?? undefined,
      dimension: params.dimension || undefined,
      key: params.key || undefined,
    },
  });
  return data;
}
